import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IInteractiveHistoryService = ( createDecorator('IInteractiveHistoryService'));
export { IInteractiveHistoryService };
